import z from "zod/v4";
import { leagueIdSchema } from "../enums/LeagueId.ts";
import {
  basketballScoreboardSchema,
  liveGameScoreTimeSeriesPointSchema,
  basketballScoresFeedItemSchema,
  liveGamePeriodSchema,
} from "./scores.ts";
import { liveBasketballGameTeamStatsSchema } from "./stats.ts";
import { teamMetadataTeamSchema } from "./teamMetadata.ts";

const pbpEventIconSchema = z.enum([
  "TV_TIMEOUT",
  "PERIOD_START_STOP",
  "STOPPAGE",
  "TEAM_LOGO",
  "PLAYER_HEADSHOT",
]);

const basketballPbpEventDtoSchema = z.object({
  id: z.string(),
  aPts: z.number(),
  hPts: z.number(),
  clockFmt: z.string(),
  clockSecs: z.number(),
  description: z.string(),
  isScoringPlay: z.boolean(),
  teamId: z.string().nullish(),
  icon: pbpEventIconSchema.nullish(),
  pbp_type: z.literal("BasketballPbpEvent"),
  period: liveGamePeriodSchema,
  sequence: z.number(),
  tags: z.array(z.string()),
});
export type BasketballPbpEventDto = z.infer<typeof basketballPbpEventDtoSchema>;

export const pbpEventSchema = z.union([basketballPbpEventDtoSchema]);
export type PbpEvent = z.infer<typeof pbpEventSchema>;

const channelInfoSchema = z.object({
  channel: z.string(),
});
export type ChannelInfo = z.infer<typeof channelInfoSchema>;

const gameStateChannelsSchema = z.object({
  scoreboard: channelInfoSchema,
  teamStats: channelInfoSchema,
  leagueScores: channelInfoSchema,
  pbpEvents: channelInfoSchema,
  gameControl: channelInfoSchema,
});
export type GameStateChannels = z.infer<typeof gameStateChannelsSchema>;

export const basketballGameStateSchema = z.object({
  game_state_type: z.literal("BasketballGameState"),
  scoreboard: basketballScoreboardSchema.optional(),
  sparkline: z.array(liveGameScoreTimeSeriesPointSchema).optional(),
  teamStats: liveBasketballGameTeamStatsSchema.optional(),
  gameControl: liveBasketballGameTeamStatsSchema.optional(),
  teamMetadata: z.record(z.string(), teamMetadataTeamSchema),
  channels: gameStateChannelsSchema,
  pbpEvents: z.array(pbpEventSchema).optional(),
});
export type BasketballGameState = z.infer<typeof basketballGameStateSchema>;

export const basketballScoresFeedSchema = z.object({
  scores_feed_type: z.literal("BasketballScoresFeed"),
  leagueId: leagueIdSchema,
  games: z.array(basketballScoresFeedItemSchema),
  teamMetadata: z.record(z.string(), teamMetadataTeamSchema),
  channelInfo: channelInfoSchema,
});
export type BasketballScoresFeed = z.infer<typeof basketballScoresFeedSchema>;

export const basketballGamePbpSchema = z.object({
  game_pbp_type: z.literal("BasketballGamePbp"),
  pbpEvents: z.array(pbpEventSchema),
  teamMetadata: z.record(z.string(), teamMetadataTeamSchema),
});

export const anyGameStateSchema = z.union([basketballGameStateSchema]);
export type AnyGameState = z.infer<typeof anyGameStateSchema>;

export const anyScoresFeedSchema = z.union([basketballScoresFeedSchema]);
export type AnyScoresFeed = z.infer<typeof anyScoresFeedSchema>;

export const anyGamePbpSchema = z.union([basketballGamePbpSchema]);
export type AnyGamePbp = z.infer<typeof anyGamePbpSchema>;
